// Default sector watchlists (D-153). On first run the app seeds one watchlist
// per GICS sector, each pre-filled with ~20 of the largest US-listed names in
// that sector by market cap. Because GICS assigns every company to exactly one
// sector, no ticker appears in more than one list — the "no duplicates across
// watchlists" guarantee is structural, not enforced at runtime.
//
// This is a SNAPSHOT of the large-caps, ordered biggest-first; it is a starting
// point the user is free to edit, reorder, or delete. All symbols are plain
// US-listed stocks so they resolve on Yahoo in Free mode. Seeding is one-time
// and guarded by a flag in confluence-store — editing this list later won't
// re-seed or overwrite a user's own changes.

export interface SectorWatchlist {
  name: string;
  tickers: string[];
}

// NB on a few classifications people find surprising (all per GICS): Visa,
// Mastercard, PayPal and Fiserv are Financials (moved from IT in 2023); Amazon
// and Tesla are Consumer Discretionary; Alphabet and Meta are Communication
// Services; the defense primes (RTX, Lockheed, General Dynamics, Northrop) sit
// in Industrials, not a sector of their own.
export const DEFAULT_SECTOR_WATCHLISTS: SectorWatchlist[] = [
  {
    name: "Information Technology",
    tickers: ["AAPL", "MSFT", "NVDA", "AVGO", "ORCL", "CRM", "CSCO", "ACN", "AMD", "ADBE", "TXN", "QCOM", "IBM", "INTU", "NOW", "AMAT", "ADI", "MU", "LRCX", "KLAC"],
  },
  {
    name: "Health Care",
    tickers: ["LLY", "UNH", "JNJ", "ABBV", "MRK", "TMO", "ABT", "DHR", "PFE", "AMGN", "ISRG", "BMY", "VRTX", "MDT", "GILD", "CI", "CVS", "ELV", "REGN", "ZTS"],
  },
  {
    name: "Financials",
    tickers: ["BRK-B", "JPM", "V", "MA", "BAC", "WFC", "GS", "MS", "AXP", "SPGI", "BLK", "C", "SCHW", "CB", "PGR", "MMC", "FI", "BX", "PNC", "USB"],
  },
  {
    name: "Consumer Discretionary",
    tickers: ["AMZN", "TSLA", "HD", "MCD", "BKNG", "LOW", "NKE", "SBUX", "TJX", "ORLY", "CMG", "MAR", "GM", "F", "HLT", "ROST", "AZO", "YUM", "DHI", "LEN"],
  },
  {
    name: "Consumer Staples",
    tickers: ["WMT", "PG", "COST", "KO", "PEP", "PM", "MO", "MDLZ", "CL", "TGT", "KMB", "GIS", "KDP", "KHC", "STZ", "SYY", "KR", "HSY", "MNST", "EL"],
  },
  {
    name: "Communication Services",
    tickers: ["GOOGL", "GOOG", "META", "NFLX", "DIS", "CMCSA", "TMUS", "T", "VZ", "CHTR", "EA", "TTWO", "WBD", "OMC", "LYV", "MTCH", "PARA", "FOXA", "NWSA", "IPG"],
  },
  {
    name: "Industrials",
    tickers: ["GE", "CAT", "RTX", "UBER", "HON", "UNP", "BA", "LMT", "DE", "ETN", "ADP", "GD", "NOC", "WM", "EMR", "CSX", "ITW", "FDX", "NSC", "PH"],
  },
  {
    name: "Energy",
    tickers: ["XOM", "CVX", "COP", "EOG", "SLB", "MPC", "PSX", "WMB", "OKE", "VLO", "HES", "OXY", "KMI", "HAL", "DVN", "FANG", "BKR", "TRGP", "CTRA", "MRO"],
  },
  {
    name: "Utilities",
    tickers: ["NEE", "SO", "DUK", "CEG", "AEP", "SRE", "D", "EXC", "XEL", "PCG", "ED", "PEG", "WEC", "EIX", "AWK", "DTE", "ETR", "PPL", "AEE", "FE"],
  },
  {
    name: "Materials",
    tickers: ["LIN", "SHW", "APD", "ECL", "FCX", "NEM", "CTVA", "DOW", "DD", "NUE", "VMC", "MLM", "PPG", "ALB", "IFF", "LYB", "STLD", "CF", "MOS", "PKG"],
  },
  {
    name: "Real Estate",
    tickers: ["PLD", "AMT", "EQIX", "WELL", "SPG", "PSA", "O", "CCI", "DLR", "VICI", "CSGP", "EXR", "AVB", "VTR", "EQR", "IRM", "WY", "INVH", "ARE", "MAA"],
  },
];
